import { faArrowUpRightFromSquare, faChevronLeft, faChevronRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Carousel, Modal } from "react-bootstrap";

const dpimg = "/img/placeholder.jpg";

const ImageGallery = ({ gallery_data }) => {
    const images = gallery_data?.images || [];
    const [showModal, setShowModal] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleView = (index) => {
        setActiveIndex(index);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    if (!images.length) return <p>No images available</p>;

    return (
        <>
            <div className="text-center">
                {/* <div className="d-flex justify-content-end align-items-center mb-3">
                    <button
                        onClick={() => { handleView(0) }}
                        className="bg-transparent gallary-view-button"
                        style={{
                            border: "none",
                            color: "#000",
                            fontSize: "26px",
                            fontWeight: "900",
                            cursor: "pointer"
                        }}
                    >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} color="#000000" size="2xs" />
                    </button>
                </div> */}

                {/* Main Carousel */}
                <Carousel
                    interval={3000}
                    className="mx-auto"
                    style={{ maxWidth: 600 }}
                    indicators={false}
                    controls={false}
                // prevIcon={<FontAwesomeIcon icon={faChevronLeft} color="#ffffff" size="3x" />}
                // nextIcon={<FontAwesomeIcon icon={faChevronRight} color="#ffffff" size="3x" />}
                >
                    {images.map((image, index) => (
                        <Carousel.Item key={index}>
                            <img
                                src={image?.gallery_image_path || dpimg}
                                alt={image?.title}
                                onError={(e) => (e.target.src = dpimg)}
                                className="img-fluid rounded"
                                style={{ maxHeight: "100%", objectFit: "contain", cursor: "pointer" }}
                                onClick={() => { handleView(0) }}
                            />
                        </Carousel.Item>
                    ))}
                </Carousel>
                <div>
                    <p className="mb-0  gallery-title">
                        {gallery_data.title.length > 100
                            ? gallery_data.title.slice(0, 100) + "..."
                            : gallery_data.title}
                    </p>
                </div>


            </div>
            {/* Modal with Fullscreen Carousel */}
            <Modal
                show={showModal}
                onHide={handleClose}
                size="xl"
                centered
                fullscreen
                contentClassName="bg-dark text-white"
            >
                <Modal.Body className="p-0">
                    <div className="d-flex justify-content-end me-2 mt-2">
                        <div className="d-flex justify-content-end me-2 mt-2">
                            <button
                                onClick={handleClose}
                                className="bg-transparent"
                                style={{
                                    border: "none",
                                    color: "#fff",
                                    fontSize: "26px",
                                    fontWeight: "900",
                                }}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                    </div>
                    <Carousel
                        activeIndex={activeIndex}
                        onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                        interval={3000}
                        className="w-100"
                        indicators={false}
                        prevIcon={<FontAwesomeIcon icon={faChevronLeft} color="#ffffff" size="3x" />}
                        nextIcon={<FontAwesomeIcon icon={faChevronRight} color="#ffffff" size="3x" />}
                    >
                        {images.map((image, index) => (
                            <Carousel.Item key={index}>
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ minHeight: "85vh" }}
                                >
                                    <img
                                        src={image?.gallery_image_path || dpimg}
                                        alt={image?.title}
                                        className="img-fluid"
                                        onError={(e) => (e.target.src = dpimg)}
                                        style={{ maxHeight: "85vh", objectFit: "contain" }}
                                    />
                                </div>
                                <div className="carousel-caption-below text-center p-3 bg-dark text-white">
                                    <h5 className="mb-1">{image.title}</h5>
                                    <p className="mb-0">{image.caption}</p>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ImageGallery;
